import { render, staticRenderFns } from "./projectEdit.vue?vue&type=template&id=32fcc82a&scoped=true"
import script from "./projectEdit.vue?vue&type=script&lang=js"
export * from "./projectEdit.vue?vue&type=script&lang=js"
import style0 from "./projectEdit.vue?vue&type=style&index=0&id=32fcc82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fcc82a",
  null
  
)

export default component.exports